module.exports = __webpack_public_path__ + "static/media/profile.577c7a33.svg";